import React from 'react';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

import { DialogContentProps } from '../../types';

function Content(props: DialogContentProps) {
  return (
    <Box
      className={cn(
        'mx-32 mb-20 rounded-8 border border-interactive-secondary bg-bg-secondary px-18 py-20',
        props.className,
      )}>
      {props.children}
    </Box>
  );
}

export default Content;
